module.exports = __webpack_public_path__ + "img/STAY HIGH_logo2.3e22a7c4.png";